import CourseSelect from './CourseSelect'
import SiftBreadcrumb from './SiftBreadcrumb'
// import CourseCardBlock from '@/components/CourseCardBlock'
import CourseCard from '@/components/CourseCard'

export default {
  CourseSelect,
  SiftBreadcrumb,
  CourseCard
}



// WEBPACK FOOTER //
// ./src/views/CourseCenter/components/index.js